module.exports = __webpack_public_path__ + "img/ltkbrasil-4x.a18d523.jpg";